import { PushCode, phfOrderMasterMessageHub as messageHub } from '@services/messageHub/instance';
import {
    IndexOrderInfo,
    isIndexOrderVo,
} from '@services/messageHub/instance/customSource/newOrderDetailPoller';
import { getGrayStateByToken, GRAY_AB_TOKEN } from '@utils/grayAB';
import { OrderBaseInfo } from '@business/pages/OrderManage/phfOrder/types';

import { ifPoiEnableAutoAcceptLocally } from '@utils/poiHelper';
import {
    reportOrderFingerprint,
    PC_ORDER_FINGERPRINT_ID,
} from '@utils/report/orderFingerprintReport';
import { recordReceiptInfo } from '@utils/report/orderReceiptReport';
import * as orderReport from '@utils/report/orderArrivalRateReport';
import { reportPhfPushMessageReceive } from '@utils/phf/PhfExposure/phfMessageCustomMetric';
import { reportCustomMetrics, CUSTOM_METRICS } from '@utils/owlReporter';
import { confirmPhfOrderAndPrint } from '../../connection/eventHandler/order/phfOrder';

/** 餐饮新形态灰度 */
const UNIFIED_ORDER_GRAY = getGrayStateByToken(GRAY_AB_TOKEN.UNIFIED_ORDER);

const getOrderInfo = (order: OrderBaseInfo | IndexOrderInfo) => {
    if (isIndexOrderVo(order)) {
        return order.commonInfo;
    } else {
        return {
            wmPoiId: order.wm_poi_id,
            wmOrderViewId: order.wm_order_id_view_str,
            orderType: order.orderType,
        };
    }
};

export default () => {
    messageHub
        // TODO: 由 newOrders 逐渐迁移到 newIndexOrders，灰度过程中存在两个结构的 VO（PhfOrderBaseInfo 或 IndexOrderInfo），全量后可以移除 PhfOrderBaseInfo。
        .getCustomSource<(OrderBaseInfo | IndexOrderInfo)[]>('newOrderDetailPoller')
        .subscribe(orders => {
            if (orders.length > 0) {
                orders.forEach(order => {
                    if (isIndexOrderVo(order)) {
                        reportCustomMetrics(CUSTOM_METRICS.ORDER_FROM_POLLER.KEY, 1, {
                            [CUSTOM_METRICS.ORDER_FROM_POLLER.TAGS.BUSINESS_TYPE]:
                                order.businessType,
                            [CUSTOM_METRICS.ORDER_FROM_POLLER.TAGS.IS_INDEX_VO]: 1,
                            [CUSTOM_METRICS.ORDER_FROM_POLLER.TAGS.INITIATOR]: 'message_hub',
                            [CUSTOM_METRICS.ORDER_FROM_POLLER.TAGS.IS_UNIFIED]: UNIFIED_ORDER_GRAY
                                ? 1
                                : 0,
                        });
                    } else {
                        reportCustomMetrics(CUSTOM_METRICS.ORDER_FROM_POLLER.KEY, 1, {
                            [CUSTOM_METRICS.ORDER_FROM_POLLER.TAGS.BUSINESS_TYPE]:
                                order.businessType,
                            [CUSTOM_METRICS.ORDER_FROM_POLLER.TAGS.IS_INDEX_VO]: 0,
                            [CUSTOM_METRICS.ORDER_FROM_POLLER.TAGS.INITIATOR]: 'message_hub',
                            [CUSTOM_METRICS.ORDER_FROM_POLLER.TAGS.IS_UNIFIED]: UNIFIED_ORDER_GRAY
                                ? 1
                                : 0,
                        });
                    }
                });

                /** 轮询新订单中需要被自动接单的部分 */
                const shouldAutoAcceptOrders = orders.filter(order =>
                    ifPoiEnableAutoAcceptLocally(
                        isIndexOrderVo(order)
                            ? `${order.commonInfo.wmPoiId}`
                            : `${order.wm_poi_id}`,
                    ),
                );

                shouldAutoAcceptOrders.forEach(order => {
                    const { wmPoiId, wmOrderViewId, orderType } = getOrderInfo(order);

                    try {
                        reportPhfPushMessageReceive(PushCode.NEW_ORDER_1, {
                            tags: {
                                autoAccept: 1,
                                from: 'poller',
                                orderViewId: isIndexOrderVo(order)
                                    ? order.commonInfo.wmOrderViewId
                                    : order.wm_order_id_view_str,
                            },
                        });
                    } catch (e) {
                        // console.log(e)
                    }
                    confirmPhfOrderAndPrint(
                        {
                            wmPoiId,
                            wmOrderViewId,
                            businessType: order.businessType,
                            orderType,
                        },
                        'auto_loop',
                    );
                    // 订单指纹上报
                    reportOrderFingerprint(
                        wmOrderViewId,
                        `${wmPoiId}`,
                        PC_ORDER_FINGERPRINT_ID.NEW_ORDER_POLLING_ARRIVE,
                        0,
                    );
                });

                recordReceiptInfo(
                    orders.map(order => {
                        const { wmPoiId, wmOrderViewId } = getOrderInfo(order);
                        return {
                            wmPoiId: `${wmPoiId}`,
                            wmOrderViewId,
                        };
                    }),
                    false,
                );

                orderReport.reportEvent(
                    orderReport.ORDER_ARRIVE_EVENT.POLLING_DETAIL_SUCCESS,
                    orders.map(order => getOrderInfo(order).wmOrderViewId),
                );
            }
        });
};
